/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { spendRulesRulesArchive } from "../funcs/spendRulesRulesArchive.js";
import { spendRulesRulesCreate } from "../funcs/spendRulesRulesCreate.js";
import { spendRulesRulesGet } from "../funcs/spendRulesRulesGet.js";
import { spendRulesRulesList } from "../funcs/spendRulesRulesList.js";
import { spendRulesRulesPreview } from "../funcs/spendRulesRulesPreview.js";
import { spendRulesRulesUpdate } from "../funcs/spendRulesRulesUpdate.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ListSpendRulesResult } from "../models/components/listspendrulesresult.js";
import { PreviewSpendRuleResult } from "../models/components/previewspendruleresult.js";
import { SpendRule } from "../models/components/spendrule.js";
import {
  ArchiveSpendRuleRequest,
  ArchiveSpendRuleSecurity,
} from "../models/operations/archivespendrule.js";
import {
  CreateSpendRuleRequest,
  CreateSpendRuleSecurity,
} from "../models/operations/createspendrule.js";
import {
  GetSpendRuleRequest,
  GetSpendRuleSecurity,
} from "../models/operations/getspendrule.js";
import {
  ListSpendRulesRequest,
  ListSpendRulesSecurity,
} from "../models/operations/listspendrules.js";
import {
  PreviewSpendRuleRequest,
  PreviewSpendRuleSecurity,
} from "../models/operations/previewspendrule.js";
import {
  UpdateSpendRuleRequest,
  UpdateSpendRuleSecurity,
} from "../models/operations/updatespendrule.js";
import { unwrapAsync } from "../types/fp.js";

export class GramRules extends ClientSDK {
  /**
   * archiveSpendRule spendRules
   *
   * @remarks
   * Archive a budget rule. There is no delete: archiving ends the rule's lineage while retaining its slug, version history, and events. Any open circuits for the rule close on the next evaluation cycle.
   */
  async archive(
    request: ArchiveSpendRuleRequest,
    security?: ArchiveSpendRuleSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(spendRulesRulesArchive(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * createSpendRule spendRules
   *
   * @remarks
   * Create a new budget rule for the current organization.
   */
  async create(
    request: CreateSpendRuleRequest,
    security?: CreateSpendRuleSecurity | undefined,
    options?: RequestOptions,
  ): Promise<SpendRule> {
    return unwrapAsync(spendRulesRulesCreate(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getSpendRule spendRules
   *
   * @remarks
   * Get a budget rule by ID.
   */
  async get(
    request: GetSpendRuleRequest,
    security?: GetSpendRuleSecurity | undefined,
    options?: RequestOptions,
  ): Promise<SpendRule> {
    return unwrapAsync(spendRulesRulesGet(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listSpendRules spendRules
   *
   * @remarks
   * List all budget rules for the current organization.
   */
  async list(
    request?: ListSpendRulesRequest | undefined,
    security?: ListSpendRulesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListSpendRulesResult> {
    return unwrapAsync(spendRulesRulesList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * previewSpendRule spendRules
   *
   * @remarks
   * Preview which actors a target expression matches and their current spend against a proposed budget. Powers the live preview in the rule editor and the per-actor breakdown in the rule detail view.
   */
  async preview(
    request: PreviewSpendRuleRequest,
    security?: PreviewSpendRuleSecurity | undefined,
    options?: RequestOptions,
  ): Promise<PreviewSpendRuleResult> {
    return unwrapAsync(spendRulesRulesPreview(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateSpendRule spendRules
   *
   * @remarks
   * Update a budget rule. Rule rows are immutable version snapshots: any change besides the enabled toggle archives the current version row and creates a successor at version + 1 (returned as the result, under a new ID). Enabled-only changes toggle the live row in place.
   */
  async update(
    request: UpdateSpendRuleRequest,
    security?: UpdateSpendRuleSecurity | undefined,
    options?: RequestOptions,
  ): Promise<SpendRule> {
    return unwrapAsync(spendRulesRulesUpdate(
      this,
      request,
      security,
      options,
    ));
  }
}
